import React from "react";
import classNames from "classnames";
import { injectIntl } from "react-intl";
import { FocusOn } from "react-focus-on";
import { CSSTransition } from "react-transition-group";
import Icon from "../Icon";
var UIModal = function(param) {
    var className = param.className, children = param.children, id = param.id, isVisible = param.isVisible, intl = param.intl, onClose = param.onClose, title = param.title;
    var classes = classNames("modal-transition", className, {
        "ui-modal-container": isVisible
    });
    return /*#__PURE__*/ React.createElement(CSSTransition, {
        in: isVisible,
        timeout: 300,
        classNames: "modal-transition"
    }, /*#__PURE__*/ React.createElement("div", {
        role: "dialog",
        "aria-labelledby": id,
        "aria-hidden": !isVisible,
        "data-testid": "modal-wrapper",
        className: classes
    }, /*#__PURE__*/ React.createElement(FocusOn, {
        className: "ui-modal__focus",
        enabled: isVisible,
        onEscapeKey: onClose,
        autoFocus: true
    }, isVisible && /*#__PURE__*/ React.createElement("div", {
        className: "ui-modal"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "ui-modal__bg"
    }), /*#__PURE__*/ React.createElement("div", {
        className: "ui-modal__content"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "ui-modal__content-header"
    }, /*#__PURE__*/ React.createElement("h2", {
        id: id
    }, title), /*#__PURE__*/ React.createElement("button", {
        type: "button",
        className: "ui-modal__close",
        "aria-label": "Close",
        onClick: onClose
    }, /*#__PURE__*/ React.createElement(Icon, {
        name: "close-line",
        size: "m"
    }), /*#__PURE__*/ React.createElement("span", {
        className: "sr-only"
    }, intl.formatMessage({
        id: "ui.close_dialog",
        defaultMessage: "Close"
    })))), /*#__PURE__*/ React.createElement("div", {
        className: "ui-modal__wrapper"
    }, children))))));
};
export default injectIntl(UIModal);
